import './rulesPopup.scss'

import React from 'react'
import Popup from '../../../../popup/Popup'
import classNames from 'classnames'
import { ReactComponent as SmallBoard } from '../../../../images/icons/ico-board.svg';
import { ReactComponent as King } from '../../../../images/icons/ico-king.svg';
import { ReactComponent as Pawn } from '../../../../images/icons/ico-pawn.svg';
import { ReactComponent as JumpRight } from '../../../../images/icons/ico-jump-right.svg';
import { ReactComponent as Clock } from '../../../../images/icons/ico-clock.svg';

export default class RulesPopup extends React.Component {
  render() {
    let timeInfo

    if (this.props.rules.time) {
      switch (true) {
        case this.props.rules.time.turn_time !== undefined:
          timeInfo = `Each player has ${
            this.props.rules.time.turn_time / 60
          } minutes for each move.`
          break

        case this.props.rules.time.player_total_time !== undefined &&
          this.props.rules.time.bonus_for_move !== undefined:
          timeInfo = `Each player has ${
            this.props.rules.time.player_total_time / 60
          } minutes for an entire game. Extra ${
            this.props.rules.time.bonus_for_move
          } seconds are added after a player's move.`
          break

        case this.props.rules.time.player_total_time !== undefined:
          timeInfo = `Each player has ${
            this.props.rules.time.player_total_time / 60
          } minutes for entire game.`
          break

        default:
          break
      }
    }

    return (
      <Popup
        className="rules"
        title="Game rules"
        buttons={[{ text: 'OK' }]}
        onClose={this.props.onClose}
        size="wide"
      >
        <div className="rules-content">

          <div className='subheader-popup'>
            <div className='icon-rules icon-clock'>
              <Clock/>
            </div>
            <div>
              {timeInfo ? (
                <div>{timeInfo}</div>
              ) : null}
            </div>
          </div>

          <div className='rules-time'></div>

          <h2
            className={classNames(
              'rules-title caption',
              'icon',
              'big',
              'flag-' + this.props.rules.icon
            )}
          >
            {this.props.rules.name}
          </h2>

          <ul className="rules-list">
            <li className="icon medium">
              <div className='icon-rules'>
                <SmallBoard/>
              </div>
              <div>
                Board {this.props.rules.boardSize}x{this.props.rules.boardSize}
              </div>
            </li>
            <li className="icon medium">
              <span className='icon-rules'>
                <King/>
              </span>
              {this.props.rules.longMoves
                ? 'Long moves possible'
                : 'Short moves only'}
            </li>
            <li className="icon medium">
              <span className='icon-rules'>
                <Pawn/>
              </span>
              {this.props.rules.captureBackwards
                ? 'Can capture backwards'
                : 'Cannot capture backwards'}
            </li>
            <li className="icon medium">
              <span className='icon-rules'>
                <JumpRight/>
              </span>
              {this.props.rules.captureMaxMandatory
                ? 'Must capture max pieces'
                : 'Does not have to capture max pieces'}
            </li>
          </ul>
        </div>
      </Popup>
    )
  }
}
